"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.holeDrag = exports.holeGravity = exports.rule_teams = exports.rule_advancedFlingPosition2 = exports.rule_advancedFlingPosition = exports.rule_requireQuadrant = exports.rule_requireOnStartingLine = exports.debug_gameSync = exports.debug_crcs_report_mismatch = exports.debug_crcs_extra_drift_checks = exports.debug_crcs_round = exports.debug_crcs = exports.debugMp_showDiscIds = exports.allowMpDebug = exports.debugSuperHoleGravity = exports.debugTokensInHole = exports.debugCollisions = exports.debugHole = exports.debugQuadrant = exports.debugIsOnStartingLine = exports.debugIsInCenter = exports.debugScoring = exports.debugGamepad = exports.debugPucks = exports.allowDebug = exports.noDebug = exports.playAreaRadius = exports.holeSensorRadius = exports.poleRadius = exports.placerSensorRadius = exports.discAngularDamping = exports.discLinearDamping = exports.discFriction = exports.discRestitution = exports.puckRadius = exports.wallLength = exports.wallThickness = exports.worldSize = exports.physicsScale = exports.physicsMultiplier = exports.CrokinoleDiscSymbols = exports.CrokinoleColors = exports.CrokinoleControlTypes = exports.CrokinolePlayerTypes = exports.CrokinoleBoardPositions = exports.CrokinoleBoardPosition = exports.CollisionGroups = exports.CollisionMembershipMultiplier = exports.CollisionGroupFlags = exports.multiplayerVersion = void 0;
exports.proto_showBattlescape = exports.proto_showGeoscape = exports.holeStillnessTolerance = exports.stillnessTolerance = exports.innerHoleDistance = exports.holeGravityMaxDistance = void 0;
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
exports.multiplayerVersion = '0.1.1-kft';
exports.CollisionGroupFlags = {
    playarea: 1,
    gutter: 2,
    both: 3,
    inactive: 0,
};
exports.CollisionMembershipMultiplier = 65536;
exports.CollisionGroups = {
    playarea: exports.CollisionGroupFlags.playarea +
        exports.CollisionGroupFlags.playarea * exports.CollisionMembershipMultiplier,
    gutter: exports.CollisionGroupFlags.gutter +
        exports.CollisionGroupFlags.gutter * exports.CollisionMembershipMultiplier,
    both: exports.CollisionGroupFlags.both +
        exports.CollisionGroupFlags.both * exports.CollisionMembershipMultiplier,
    inactive: exports.CollisionGroupFlags.inactive +
        exports.CollisionGroupFlags.inactive * exports.CollisionMembershipMultiplier,
};
exports.CrokinoleBoardPosition = {
    bottom: 0,
    left: 1,
    top: 2,
    right: 3,
};
exports.CrokinoleBoardPositions = [
    exports.CrokinoleBoardPosition.bottom,
    exports.CrokinoleBoardPosition.left,
    exports.CrokinoleBoardPosition.top,
    exports.CrokinoleBoardPosition.right,
];
exports.CrokinolePlayerTypes = [
    'none',
    'human',
    'ai-easy',
];
exports.CrokinoleControlTypes = [
    'mouse',
    'gamepad-1',
    'gamepad-2',
    'gamepad-3',
    'gamepad-4',
    'gamepad-5',
    'gamepad-6',
    'gamepad-7',
    'gamepad-8',
];
exports.CrokinoleColors = [
    {
        name: 'Blue',
        tint: 0x4f8fba,
    },
    {
        name: 'Green',
        tint: 0x75a743, // diveColors.green,
    },
    {
        name: 'Brown',
        tint: 0xc09473,
    },
    {
        name: 'Orange',
        tint: 0xbe772b,
    },
    {
        name: 'Red',
        tint: 0xa53030, //diveColors.peach,
    },
    {
        name: 'Pink',
        tint: 0xa23e8c, //.red,
    },
    {
        name: 'Grey',
        tint: 0x394a50,
    },
];
exports.CrokinoleDiscSymbols = [
    {
        name: 'None',
        frame: null,
    },
    {
        name: 'Star',
        frame: sprites_sidecar_1.sprites.crokinoleDiscStar[0],
    },
    {
        name: 'Leaf',
        frame: sprites_sidecar_1.sprites.crokinoleDiscLeaf[0],
    },
    {
        name: 'Spiral',
        frame: sprites_sidecar_1.sprites.crokinoleDiscSpiral[0],
    },
    {
        name: 'Smile',
        frame: sprites_sidecar_1.sprites.crokinoleSymbolSmile[0],
        scale: 0.75,
    },
    {
        name: 'Ukulele',
        frame: sprites_sidecar_1.sprites.crokinoleSymbolUkulele[0],
    },
    {
        name: 'Poodle',
        frame: sprites_sidecar_1.sprites.crokinoleAnimalPoodle[0],
        scale: 0.55,
        noTint: false,
    },
    {
        name: 'Wrench',
        frame: sprites_sidecar_1.sprites.crokinoleItemWrench2[0],
        scale: 1,
        noTint: false,
    },
    {
        name: 'Alien',
        frame: sprites_sidecar_1.sprites.crokinoleMonsterAlien[0],
        scale: 0.67,
        noTint: true,
    },
    {
        name: 'Extinguisher',
        frame: sprites_sidecar_1.sprites.crokinoleItemExtinguisher[0],
        scale: 1,
        noTint: true,
    },
    {
        name: 'Coffee',
        frame: sprites_sidecar_1.sprites.crokinoleItemCoffee[0],
        scale: 2,
        noTint: true,
    },
    {
        name: 'Archer',
        frame: sprites_sidecar_1.sprites.diveHeroes2WeeMonsArcherAtkR1Png[0],
        scale: 0.9,
        noTint: true,
    },
    {
        name: 'Swordfighter',
        frame: sprites_sidecar_1.sprites.diveHeroes2WeeMonsFighterAtkR2Png[0],
        scale: 0.9,
        noTint: true,
    },
    {
        name: 'Wizard',
        frame: sprites_sidecar_1.sprites.diveHeroes2WeeMonsMageAtkR2Png[0],
        scale: 0.9,
        noTint: true,
    },
];
exports.physicsMultiplier = 1 / 100;
// let cOx = 0
// let cOy = 0
// Render scale
exports.physicsScale = 120; // Target is 128?
exports.worldSize = 781 * exports.physicsMultiplier;
// let worldWidth = worldSize
// let worldHeight = worldSize
exports.wallThickness = 32 * exports.physicsMultiplier;
exports.wallLength = 715 * exports.physicsMultiplier;
exports.puckRadius = (32 / 2) * exports.physicsMultiplier;
exports.discRestitution = 0.9;
exports.discFriction = 0.9;
// .setRestitution(0.95)
// .setFriction(0.9)
exports.discLinearDamping = 0.95;
exports.discAngularDamping = 0.5;
exports.placerSensorRadius = (35 / 2) * exports.physicsMultiplier;
exports.poleRadius = (9.5 / 2) * exports.physicsMultiplier;
exports.holeSensorRadius = (35 / 2) * exports.physicsMultiplier;
exports.playAreaRadius = ((662 + 10) / 2) * exports.physicsMultiplier;
exports.noDebug = true;
exports.allowDebug = !exports.noDebug;
exports.debugPucks = true && exports.allowDebug;
exports.debugGamepad = false;
exports.debugScoring = false && exports.allowDebug;
exports.debugIsInCenter = false && exports.allowDebug;
exports.debugIsOnStartingLine = false && exports.allowDebug;
exports.debugQuadrant = false && exports.allowDebug;
exports.debugHole = false && exports.allowDebug;
exports.debugCollisions = true && exports.allowDebug;
exports.debugTokensInHole = true && exports.allowDebug;
exports.debugSuperHoleGravity = true && exports.allowDebug;
exports.allowMpDebug = true;
exports.debugMp_showDiscIds = true && exports.allowMpDebug;
exports.debug_crcs = false;
exports.debug_crcs_round = false;
exports.debug_crcs_extra_drift_checks = true;
exports.debug_crcs_report_mismatch = false;
exports.debug_gameSync = false;
exports.rule_requireOnStartingLine = true || exports.noDebug;
exports.rule_requireQuadrant = true || exports.noDebug;
exports.rule_advancedFlingPosition = false; // || noDebug
exports.rule_advancedFlingPosition2 = false; // || noDebug
exports.rule_teams = true;
// Add hole gravity
exports.holeGravity = 0.003;
exports.holeDrag = 0.002;
exports.holeGravityMaxDistance = 0.15;
exports.innerHoleDistance = exports.holeGravityMaxDistance / 2;
exports.stillnessTolerance = 0.02;
exports.holeStillnessTolerance = 0.25;
exports.proto_showGeoscape = false;
exports.proto_showBattlescape = true;
